import { List, ListItem, Typography } from "@mui/material";
import Box from "@mui/material/Box";

export default function FtdDrawer() {
  return (
    <Box>
      <Typography variant="h6" mb={1}>Prediction Focus: FTD</Typography>
      <Box>
        <Typography variant="subtitle1" color="secondary" fontWeight={500}>
          Mandatory Input Metrics:
        </Typography>
        <List sx={{ paddingLeft: 1 }}>
          {[
            "Growth Target",
            "Avg Net Rev To Active Users",
            "CPA PV",
            "CVR",
            "Profit",
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                padding: 0,
                color: "#00000099",
                marginBottom: 1,
                fontWeight: "500",
              }}
            >
              • {item}
            </ListItem>
          ))}
        </List>
      </Box>
      <Box>
        <Typography variant="subtitle1" color="secondary" fontWeight={500}>
          Optional Input Metrics:
        </Typography>
        <List sx={{ paddingLeft: 1 }}>
          {[
            "Churn Rate",
            "Acquired to FTD",
            "Avg RS Percent",
            "RS BR to BR Active Percent ",
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                padding: 0,
                color: "#00000099",
                marginBottom: 1,
                fontWeight: "500",
              }}
            >
              • {item}
            </ListItem>
          ))}
        </List>
      </Box>
      <Box>
        <Typography variant="subtitle1" color="secondary" fontWeight={500}>
          Calculated Metrics:
        </Typography>
        <List sx={{ paddingLeft: 1 }}>
          {[
            "FTD",
            "Active Users",
            "Old Users",
            "Acquired Users",
            "Net Rev",
            "RS",
            "RS PV",
            "CPA Income",
            "Total Income",
            "Clicks",
            "EPC CPA",
            "EPC RS",
            "EPC",
            "CPC",
            "CAC",
            "Spend",
          ].map((item, index) => (
            <ListItem
              key={index}
              sx={{
                padding: 0,
                color: "#00000099",
                marginBottom: 1,
                fontWeight: "500",
              }}
            >
              • {item}
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
